const { getElement } = window.BAO.Utils

function getHeaderHeight () {
  const style = window.getComputedStyle(document.body)
  const announcementBarHeight = parseInt(
    style.getPropertyValue('--AnnouncementBar_Height'),
    10,
  )
  const headerHeight = parseInt(
    style.getPropertyValue('--HeaderBanner_Height'),
    10,
  )

  return `${announcementBarHeight + headerHeight}px`
}

class FloatingButtons extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.dismissedButtons =
      JSON.parse(sessionStorage.getItem('dismissedFloatingButtons')) || []

    this.showButtons()

    this.observer = new IntersectionObserver(
      this.handleObservation.bind(this),
      {
        rootMargin: `-${getHeaderHeight()} 0px 0px 0px`,
      },
    )
  }

  setupListeners () {
    super.setupListeners()

    this.els.close?.elements.forEach(el => {
      this.listeners.add(el, 'click', () => this.handleCloseClick(el))
    })

    if (this.triggerElement) {
      this.observer.observe(this.triggerElement)
    } else {
      this.setVisible(true)
    }
  }

  showButtons () {
    this.els.button?.elements.forEach(el => {
      if (Shopify.designMode) {
        el.setAttribute('aria-hidden', 'false')
        return
      }

      if (this.dismissedButtons.includes(el.id)) return

      el.setAttribute('aria-hidden', 'false')
    })
  }

  handleCloseClick (element) {
    const target = element.closest('[data-floating-buttons-el="button"]')

    if (target === null) return

    target.setAttribute('aria-hidden', 'true')

    this.dismissedButtons.push(target.id)

    sessionStorage.setItem(
      'dismissedFloatingButtons',
      JSON.stringify(this.dismissedButtons),
    )
  }

  /** @type {IntersectionObserverCallback} */
  handleObservation (entries) {
    const hasVisibleTarget = entries.some(entry => entry.isIntersecting)

    this.setVisible(!hasVisibleTarget)
  }

  /** @param {boolean} visible */
  setVisible (visible) {
    this.setAttribute('aria-hidden', !visible)
  }

  get triggerElement () {
    if (
      !this.hasAttribute('hide-target') ||
      this.getAttribute('hide-target') === ''
    ) { return null }
    return getElement(`#${this.getAttribute('hide-target')}`)
  }
}

if (!window.customElements.get('floating-buttons')) {
  window.customElements.define('floating-buttons', FloatingButtons)
}
